/**
 * Free-text search over entities, regions, dimensions and categories.
 *
 * Dimensions and categories are searchable on purpose: typing a capability is
 * the fastest way into assisted discovery, which is why hits of those types open
 * Discover pre-filtered rather than a profile.
 */
import { C, DIMS, REGIONS, REGION_VIEW, CATS_ALL, byName, TIER_NAME, tierOf, colorOf } from '../model.js';
import { flyToLL } from '../globe/scene.js';
import { h } from '../untrusted.js';
import { openCountry, openRegion, openDiscover } from './drawer.js';

const searchEl=document.getElementById('search'), sug=document.getElementById('suggest');
const ENTRIES=[...C.map(c=>({t:'country',n:c.n})), ...REGIONS.map(r=>({t:'region',n:r})),
  ...DIMS.map(d=>({t:'capability',n:d})),
  ...CATS_ALL.map(x=>({t:'capcat', n:x.c, d:x.d}))];   // assisted discovery: capabilities & categories are searchable
searchEl.addEventListener('input', ()=>{
  const q=searchEl.value.trim().toLowerCase();
  if(!q){ sug.classList.remove('open'); return }
  const hits=ENTRIES.filter(e=>e.n.toLowerCase().includes(q)).slice(0,9);
  sug.innerHTML=String(h`${hits.length ? hits.map(e=>{
    if(e.t==='country'){ const c=byName[e.n];
      return h`<button class="sg" data-t="country" data-n="${e.n}"><span class="dot" style="background:${colorOf(c)}"></span>${e.n}<span class="tag">${TIER_NAME[tierOf(c.overall)]}</span></button>` }
    if(e.t==='capability')
      return h`<button class="sg" data-t="capability" data-n="${e.n}"><span class="dot" style="background:var(--brass)"></span>${e.n}<span class="tag">CAPABILITY</span></button>`;
    if(e.t==='capcat')
      return h`<button class="sg" data-t="capcat" data-n="${e.n}" data-d="${e.d}"><span class="dot" style="background:var(--brass)"></span>${e.n}<span class="tag">${e.d.toUpperCase()}</span></button>`;
    return h`<button class="sg" data-t="region" data-n="${e.n}"><span class="dot" style="background:var(--ink3)"></span>${e.n}<span class="tag">REGION</span></button>`;
  }) : h`<div class="sg" style="color:var(--ink3)">No matches</div>`}`);
  sug.classList.toggle('open',hits.length>0);
  sug.querySelectorAll('.sg[data-n]').forEach(b=> b.onclick=()=>{
    sug.classList.remove('open'); searchEl.value='';
    if(b.dataset.t==='country') openCountry(byName[b.dataset.n]);
    else if(b.dataset.t==='capability') openDiscover(b.dataset.n);
    else if(b.dataset.t==='capcat') openDiscover(b.dataset.d, b.dataset.n);
    else { const r=b.dataset.n, v=REGION_VIEW[r]; if(v) flyToLL(v[0],v[1],2.3); openRegion(r) }
  });
});
searchEl.addEventListener('keydown', e=>{ if(e.key==='Enter'){ const f=sug.querySelector('.sg[data-n]'); if(f) f.click() }});
document.addEventListener('click', e=>{ if(!e.target.closest('#searchwrap')) sug.classList.remove('open') });
